import styled from "styled-components";
import { QRCodeCanvas } from "qrcode.react";
import { ReactComponent as LockerSvg } from "../assets/locker.svg";

const LockerIcon = styled(LockerSvg)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  color: ${({ color }) => color}; // outer square uses currentColor in SVG
  z-index: 1;
`;

const CardWrapper = styled.div`
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.35);

  padding: 14px 16px 16px;

  @media (max-width: 500px) {
    padding: 8px 10px 10px;
  }
`;


const Inner = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 6px;

  @media (max-width: 600px) {
    display: none;
  }
`;

const ChainName = styled.h2`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;

  @media (max-width: 500px) {
    font-size: 0.5rem;
    letter-spacing: 0.04em;
  }
`;

const ChainTicker = styled.span`
  font-size: 0.9rem;
  opacity: 0.9;

  @media (max-width: 500px) {
    font-size: 0.4rem;
  }
`;

const AddressTap = styled.button`
  margin-top: 6px;
  border: none;
  outline: none;
  width: 100%;
  border-radius: 999px;
  padding: 5px 12px;
  background: rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(8px);
  color: #ffffff;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  transition: transform 0.08s ease, box-shadow 0.08s ease, background 0.18s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 5px 12px rgba(15, 23, 42, 0.4);
    background: rgba(15, 23, 42, 0.34);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
    background: rgba(15, 23, 42, 0.4);
  }
`;

const AddressText = styled.code`
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CopySymbol = styled.span`
  font-size: 0.9rem;
  opacity: 0.9;
`;

const MiddleSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const QRWrapper = styled.div`
  margin-top: 8px;
  padding: 10px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.25);
`;

const BottomRow = styled.div`
  margin-top: 8px;
  font-size: 0.7rem;
  opacity: 0.9;
  text-align: center;
`;

const truncateAddress = (str) => {
  if (!str) return "";
  return str.length > 18
    ? `${str.slice(0, 7)}…${str.slice(-7)}`
    : str;
};

const getQrValue = (chain) => {
  const addr = chain.address;
  const label = encodeURIComponent(chain.chainName || "");

  switch (chain.ticker?.toUpperCase()) {
    default:
      return addr;
  }
};

function Card({ chain, onCopy }) {
  const qrValue = getQrValue(chain);

  const handleCopyClick = () => {
    onCopy(chain);
  };

  return (
    <CardWrapper>
      {/* Locker SVG background tinted by chain.color */}
      <LockerIcon color={chain.color} />

      <Inner>
        <TopRow>
          {/* Wallet name at the top (e.g. DRAGONMASTERDX.LOCKER) */}
          <ChainName>{chain.chainName}</ChainName>
          <ChainTicker>{chain.ticker}</ChainTicker>
        </TopRow>

        <AddressTap
          onClick={handleCopyClick}
          aria-label={`Copy ${chain.chainName} address`}
        >
          <AddressText>{truncateAddress(chain.address)}</AddressText>
          <CopySymbol>⧉</CopySymbol>
        </AddressTap>

        <MiddleSection>
          <QRWrapper>
            <QRCodeCanvas
              value={qrValue}
               size={window.innerWidth < 500 ? 100 : 150}
              bgColor="transparent"
              fgColor="#111827"
              includeMargin={false}
              level="M"
              imageSettings={
                chain.logo
                  ? {
                      src: chain.logo,
                      height: 30,
                      width: 30,
                      excavate: true,
                    }
                  : undefined
              }
            />
          </QRWrapper>
        </MiddleSection>

      </Inner>
    </CardWrapper>
  );
}

export default Card;
